import type { IconData } from '@stacksjs/iconify-core'

export const golfAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M161.846 320h192l4.923-32h-192z\"/><path fill=\"currentColor\" d=\"M467.122 16L450.7 128h-29.525L439.49 16h-32.425l-35.321 216H155.819a48.05 48.05 0 0 0-47.152 39.019l-9.354 49.106A88 88 0 1 0 188.673 432H314.05a144 144 0 0 0 142.589-123.889L499.464 16ZM104 464a56 56 0 1 1 56-56a56.063 56.063 0 0 1-56 56m320.963-160.433A111.27 111.27 0 0 1 400 359.585A113.6 113.6 0 0 1 371.477 384a111.2 111.2 0 0 1-57.427 16H191.633a87.3 87.3 0 0 0-5.657-24h159.255l4.923-32H164.333q-2.626-2.476-5.451-4.735a87.9 87.9 0 0 0-27.783-14.99L139.532 280l.571-2.994A16.015 16.015 0 0 1 155.819 264h243.117l17.006-104h30.068Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default golfAlt
